/** @jsx jsx */
import { jsx } from '@emotion/core'
import { observer } from 'mobx-react'
import React, { Fragment } from 'react'
import BettingHistoryTab from '@views/BettingHistory/BettingHistoryTab'
// css
import { PageBgStyle } from '@styles/base.style'
import { Button } from '@styles/button.style'
// icon
import useRootStore from '@store/useRootStore'
import { useOnMount } from '@utils/reactExt'
import BettingHistoryBg from '@assets/images/bg/betting-history-bg.png'
import { BettingListSelectorWrap, ModalBottomBtnStyle } from './index.style'


const BettingListSelectorPopup: React.FC = () => {
  const { pickStore, globalStore } = useRootStore()

  // full-modal className 을 붙이기 위해.
  const isFullModal = true

  const fetchPublishItem = async () => {
    await pickStore.fetchPublishPick({})
  }

  useOnMount(fetchPublishItem)

  const onClickBetHistoryItemUploadHandler = () => {
    globalStore.closeGeneralPopup()
    globalStore.setVisibleBettingListPopup(false)
  }

  return (
    <Fragment>
      <BettingListSelectorWrap>
        <div css={PageBgStyle} className="betting-history-bg">
          <img src={BettingHistoryBg} alt="야구선수 배경"/>
        </div>
        <BettingHistoryTab isFullModal={isFullModal}/>
      </BettingListSelectorWrap>

      <Button primary css={ModalBottomBtnStyle} onClick={onClickBetHistoryItemUploadHandler}>확인</Button>
    </Fragment>
  )
}

export default observer(BettingListSelectorPopup)
